import React, { useContext } from "react";
import { REPORT_PAGES_ROUTES } from "../../../../constants";
import { focusTamperingIssue } from "../../../../store/issuesDiffSlice";
import { LinkToReportTab } from "../../../common";
import { ReportContext } from "../../../context";
import { useReportDispatch } from "../../../hooks";
import ChangeCategoryCard from "./ChangeCategoryCard";
import styles from "./diffChanges.module.scss";
const ThreatHuntingChanges = ({ violations, }) => {
    const { selectedCheck } = useContext(ReportContext);
    const dispatch = useReportDispatch();
    const to = selectedCheck === "scan-repro"
        ? REPORT_PAGES_ROUTES.REPRODUCIBILITY_ROUTE
        : `${REPORT_PAGES_ROUTES.VERSION_DIFF}/${REPORT_PAGES_ROUTES.VERSION_DIFF_THREAT_HUNTING}`;
    const added = violations.map((violation, index) => (React.createElement("div", { key: violation.id, className: styles["change-line"] },
        React.createElement(LinkToReportTab, { underline: "hover", id: `file-${index}-tampering-${violation.id}`, to: to, className: styles["issue-link"], inline: true, onClick: () => dispatch(focusTamperingIssue(violation.id)), color: "link" }, violation.id),
        ` - ${violation.description}`)));
    return (React.createElement(ChangeCategoryCard, { title: "Threat hunting", added: added, removed: [] }));
};
export default ThreatHuntingChanges;
//# sourceMappingURL=ThreatHuntingChanges.js.map